import React from 'react'
import { Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SideBarLoader from './SidebarLoader';

const SuperAdminOrSubMenu = ({ menu ,loading}) => {
    if(loading)return <SideBarLoader/>
    return (
        <ul className="nav">
            <Accordion defaultActiveKey="2" >
                {menu.map((item, idx) => {

                    // Simple link (no children)
                    if (!item.children) {
                        return (
                            <li className="nav-item" key={idx}>
                                <Link className="nav-link" to={item.to}>
                                    {item.icon && <i className={`mr-2 ${item.icon}`} />}
                                    {item.label}
                                </Link>
                            </li>
                        );
                    }

                    // Accordion group
                    return (
                        <li className="nav-group" key={idx}>
                            <Accordion.Item eventKey={String(idx)}>
                                <Accordion.Header >
                                    {item.icon && <i className={`mr-2 ${item.icon}`} />}
                                    {item.label}
                                </Accordion.Header>

                                <Accordion.Body>
                                    <ul className="nav-group-items">
                                        {item.children.map((child, cIdx) => (
                                            <li className="nav-item" key={cIdx}>
                                                <Link className="nav-link" to={child.to}>
                                                    {child.icon && (
                                                        <i className={`mr-2 ${child.icon}`} />
                                                    )}
                                                    {child.label}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        </li>
                    );
                })}
            </Accordion>
        </ul>
    );
}

export default SuperAdminOrSubMenu